export const MONTHLY = 'monthly';
export const ANNUALLY = 'annually';
export const ONE_TIME_FEE = 'oneTimeFee';